<template>
	<div class="section">
		<h1>Welcome to 星梦启航</h1>
		<p>我们的目标是减少信息差，整合推荐资源。</p>
	</div>
</template>

<script setup>
</script>

<style scoped>
.section {
	text-align: center;
	font-size: 2em;
	padding: 20px;
}
</style>